import { AfterViewInit, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-form-tenant-address',
  template: `
    <form [formGroup]="userAddressForm" (ngSubmit)="saveAddress()">
      <div class="form-group mt-4">
        <label for="zip_code" class="form-control-label text-sm">Código postal</label>
        <input type="text" class="form-control" [formControl]="regionControl">
        <div *ngIf="cpResults.length > 0">
          <div class="list-group">
            <a class="list-group
            -item list-group-item-action" *ngFor="let result of cpResults" (click)="selectCP(result)">
              {{result.settlement}} - {{result.municipality}} {{result.city}} {{result.country}}</a>
          </div>
        </div>
        <div *ngIf="tad['zip_code']?.touched && tad['zip_code']?.invalid">
          <div *ngIf="tad['zip_code'].errors?.['required']" class="text-danger text-sm">El Código Postal es requerido.</div>
        </div>
      </div>

      <div class="form-group mt-3">
        <label for="address" class="form-control-label text-sm">Calle</label>
        <input type="text" formControlName="address" class="form-control" id="address">
        <div *ngIf="tad['address']?.touched && tad['address']?.invalid">
          <div *ngIf="tad['address'].errors?.['required']" class="text-danger text-sm">La calle es requerido.</div>
        </div>
      </div>
      <div class="form-group mt-3">
        <label for="outer_number" class="form-control-label text-sm">Número exterior</label>
        <input type="text" formControlName="outer_number" class="form-control" id="outer_number">
        <div *ngIf="tad['outer_number']?.touched && tad['outer_number']?.invalid">
          <div *ngIf="tad['outer_number'].errors?.['required']" class="text-danger text-sm">La calle es requerido.</div>
        </div>
      </div>
      <div class="form-group mt-3">
        <label for="state" class="form-control-label text-sm">Estado</label>
        <input class="form-control" id="state" formControlName="state">
        <!-- select class="form-select form-select-lg" id="state" formControlName="state">
          <option *ngFor="let state of catalogs.edos" [value]="state.value">{{state.name}}</option>
        </!-->
        <div *ngIf="tad['state']?.touched && tad['state']?.invalid">
          <div *ngIf="tad['state'].errors?.['required']" class="text-danger text-sm">El estado es requerido.</div>
        </div>
      </div>
      <div class="form-group mt-3">
        <label for="city" class="form-control-label text-sm">Ciudad</label>
        <input type="text" formControlName="city" class="form-control" id="city">
        <div *ngIf="tad['city']?.touched && tad['city']?.invalid">
          <div *ngIf="tad['city'].errors?.['required']" class="text-danger text-sm">La ciudad es requerido.</div>
        </div>
      </div>
      <div class="form-group mt-3">
        <label for="zip_code" class="form-label">Código postal</label>
        <input type="text" class="form-control" [formControl]="regionControl">
      
        
        <!-- input type="text" formControlName="zip_code" class="form-control form-control-lg rounded-3" -->
        <div *ngIf="tad['zip_code']?.touched && tad['zip_code']?.invalid">
          <div *ngIf="tad['zip_code'].errors?.['required']" class="text-danger text-sm">El Código Postal es requerido.</div>
        </div>
      </div>
      <div class="form-group mt-5 mb-2 text-end">
        <button type="submit" class="btn btn-outline-secondary">
          <fa-icon [icon]="icons.faSave" class="me-2" *ngIf="!loading"></fa-icon>
          Guardar
        </button>
      </div>
    </form>
  `,
  styleUrls: []
})
export class FormTenantAddressComponent implements AfterViewInit {
  @Input() user: any = {};
  @Input() address: any = {};
  @Input() catalogs: any = {};

  @Output() save: EventEmitter<any> = new EventEmitter();

  userAddressForm: FormGroup = new FormGroup({});
  regionControl = new FormControl();

  loading: boolean = false;

  cpResults: any[] = [];
  
  constructor(
    private store: SettlementsService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public icons: IconsService
  ) {
    this.initForm();
  }

  get tad() { return this.userAddressForm.controls; }

  ngAfterViewInit(): void {
    console.log('ADDRESS ==> ', this.address);
    if (this.address) {
      this.userAddressForm.patchValue(this.address);
    }

    this.regionControl.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap(query => this.store.getTenantRegions(query))
    ).subscribe((results: any) => {
      console.log('RESULTS ==> ', results);
      this.cpResults = results;
    });

    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['address'] && changes['address'].currentValue) {
      console.log('CHANGES ADDRESS ==> ', changes['address'].currentValue);
      this.userAddressForm.patchValue(changes['address'].currentValue);
    }
  }

  initForm() {
    this.userAddressForm = this.fb.group({
      id: [''],
      address: ['', [Validators.required]],
      outer_number: ['', [Validators.required]],
      state: ['', [Validators.required]],
      city: ['', [Validators.required]],
      zip_code: ['', [Validators.required]],
      tenant_id: [''],
      region_id: [''],
      country: ['']
    });
  }

  selectCP(result: any) {
    this.userAddressForm.patchValue({
      zip_code: result.postalCode,
      city: result.city,
      state: result.municipality,
      region_id: result.id,
      country: result.country
    });

    this.cpResults = [];
  }

  saveAddress() {
    if (!this.userAddressForm.valid) {
      this.toastr.error('Por favor, llena todos los campos requeridos');
      return;
    }

    this.userAddressForm.patchValue({ tenant_id: this.user.id });

    this.save.emit(this.userAddressForm.value);
  }

}
